import React, { useEffect, useState } from "react";
import { DatePicker, message, Select, Space, Table, Typography } from "antd";
import { useParams } from "react-router-dom";
import { api } from "../../api/api";
import { Batch } from "../../types/material.type";

const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

export default function Batches() {
  const { itemId, type, name } = useParams();
  const [batches, setBatches] = useState<Batch[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState<string>("name");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<[any, any] | undefined>(undefined);

  const fetchBatches = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/${type}/${itemId}/batches`, {
        params: {
          page,
          limit: pageSize,
          sortBy,
          order: sortOrder,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });
      setBatches(response.data.batches);
      setTotal(response.data.total);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение партий.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBatches();
  }, [page, pageSize, sortBy, sortOrder, dateRange]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Кол-во",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Остаток",
      dataIndex: "residue",
      key: "residue",
    },
    {
      title: "Партия производства",
      key: "isProducing",
      render: (_: any, batch: Batch) => (batch.isProducing ? "Да" : "Нет"),
    },
    {
      title: "Себестоимость в USD",
      key: "primeCosts",
      render: (_: any, batch: Batch) => batch.primeCost.USD,
    },
    {
      title: "Себестоимость в TJS",
      key: "primeCosts",
      render: (_: any, batch: Batch) => batch.primeCost.TJS,
    },
  ];
  
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Партии {name}</Title>
      <Space style={{ marginBottom: 16 }}>
        <Select
          placeholder="Сортировать по"
          defaultValue="date"
          onChange={(value) => setSortBy(value)}
          style={{ width: 150 }}
        >
          <Option value="date">Дата</Option>
          <Option value="quantity">Кол-во</Option>
          <Option value="residue">Остаток</Option>
        </Select>
        <Select
          defaultValue="desc"
          onChange={(value: "asc" | "desc") => setSortOrder(value)}
          style={{ width: 120 }}
        >
          <Option value="asc">По возрастанию</Option>
          <Option value="desc">По убыванию</Option>
        </Select>
        <RangePicker
          onChange={(dates) => setDateRange(dates ?? undefined)}
          placeholder={["Начало", "Конец"]}
          format={{ format: "DD.MM.YY" }}
        />
      </Space>
      <Table
        loading={loading}
        columns={columns}
        dataSource={batches}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
